import React from 'react';
import C from '../../constants/colors';

export default function SidebarItem({ icon: Icon, label, badge, active, onClick, indent = false }) {
  return (
    <div
      className={`sidebar-item${active ? ' active' : ''}`}
      onClick={onClick}
      style={{
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: indent ? '7px 12px 7px 36px' : '8px 12px',
        borderRadius: '8px', marginBottom: '2px',
        background: active ? 'rgba(59,130,246,0.12)' : 'transparent',
        borderLeft: active ? `2px solid ${C.blue}` : '2px solid transparent',
        userSelect: 'none',
      }}
    >
      {Icon && <Icon size={indent ? 14 : 16} color={active ? C.blue : C.textSecondary} style={{ flexShrink: 0 }} />}
      <span style={{
        flex: 1, fontSize: indent ? '12px' : '13px',
        fontWeight: active ? 500 : 400,
        color: active ? C.textPrimary : C.textSecondary,
        whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
      }}>
        {label}
      </span>
      {badge != null && badge > 0 && (
        <span style={{
          background: C.red, color: '#fff', fontSize: '10px', fontWeight: 700,
          padding: '1px 6px', borderRadius: '10px', minWidth: '18px',
          textAlign: 'center', lineHeight: '16px', flexShrink: 0,
        }}>
          {badge > 99 ? '99+' : badge}
        </span>
      )}
    </div>
  );
}
